import React from "react"
import ReactDOM from "react-dom/client"
import {App} from "./App.tsx";
import {router} from "./router.tsx";

if (import.meta.env.MODE != "prod") {
    console.info(`📦 App version: ${__APP_VERSION__}`);
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App router={router}/>
    </React.StrictMode>
)
